module.exports = __webpack_public_path__ + "static/media/MO.626ec242.png";